<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'professores' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Professor
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider name="Nome Completo" rules="required" v-slot="{ errors }">
              <e-label>Nome Completo</e-label>
              <v-text-field :error-messages="errors" v-model="form.nome" dense solo />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Email</e-label>
            <v-text-field v-model="form.email" dense solo /> </v-col
          ><v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider name="CPF" rules="required" v-slot="{ errors }">
              <e-label>Número do CPF</e-label>
              <v-text-field
                :error-messages="errors"
                v-mask="'###.###.###-##'"
                v-model="form.cpf"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="5">
            <e-label>Identificação única(INEP)</e-label>
            <v-text-field v-model="form.codigo" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Carga horária exercício</e-label>
            <v-text-field v-model="form.ch_exercicio" dense solo v-mask="'####'" />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider name="Data de nascimento" rules="required" v-slot="{ errors }">
              <e-label>Data de nascimento</e-label>
              <e-date-picker :error-messages="errors" v-model="form.dataNascimento" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Matrícula</e-label>
            <v-text-field v-mask="'####-#'" v-model="form.matricula" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Vinculo</e-label>
            <e-autocomplete
              :items="$constants.vinculo"
              :return-object="false"
              :item-value="(value) => value.desc"
              :item-text="(value) => value.desc"
              v-model="form.vinculo"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Função</e-label>
            <v-text-field v-model="form.funcao" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Classe</e-label>
            <v-text-field v-model="form.classe" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Nível</e-label>
            <v-text-field v-model="form.nivel" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="2">
            <ValidationProvider name="Data de admissão" rules="required" v-slot="{ errors }">
              <e-label>Data de admissão</e-label>
              <e-date-picker :error-messages="errors" v-model="form.data_admissao" />
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Filiação 1</e-label>
            <v-text-field v-model="form.filiacao1" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Filiação 2</e-label>
            <v-text-field v-model="form.filiacao2" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Sexo</e-label>
            <e-autocomplete
              :items="$constants.sexoList"
              :return-object="false"
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="form.sexo_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Cor/Raça</e-label>
            <e-autocomplete
              :items="$constants.corOuRacaList"
              :return-object="false"
              v-model="form.cor_ou_raca"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Nacionalidade</e-label>
            <e-autocomplete
              :items="$constants.nacionalidadeList"
              :return-object="false"
              v-model="form.naturalidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>País de nacionalidade</e-label>
            <v-text-field v-model="form.nacionalidade" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Município de nascimento</e-label>
            <v-text-field v-model="form.municipalidade" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>UF de nascimento</e-label>
            <e-autocomplete
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.estadualidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="8">
            <e-label
              >Profissional escolar com deficiência, transtorno do espectro autista ou altas
              habilidades/superdotação</e-label
            >
            <v-switch v-model="form.especial"></v-switch>
          </v-col>
          <v-col cols="12">
            <h4>
              Tipo de deficiência, transtorno do espectro autista ou altas habilidades/superdotação
            </h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Deficiência / TEA / Altas Habilidades</e-label>

            <e-autocomplete
              clearable
              :items="condicoesList"
              :return-object="false"
              :item-value="(item) => item.id"
              :item-text="(item) => item.descricao"
              v-model="form.condicoes"
              label="Selecione uma ou mais opções"
              multiple
              chips
              small-chips
              dense
              solo
            />
          </v-col>
          <v-col cols="12">
            <h4>DADOS SOBRE A ÁREA RESIDENCIAL DO(A) PROFISSIONAL(A) ESCOLAR</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label> País de residência </e-label>
            <v-text-field v-model="form.pais_residencia" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label> CEP </e-label>
            <v-text-field v-mask="'#####-###'" value="" v-model="form.cep" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <e-label> Logradouro </e-label>
            <v-text-field v-model="form.logradouro" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="1">
            <e-label> Número </e-label>
            <v-text-field value="" v-model="form.numero" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="2">
            <e-label> Bairro </e-label>
            <v-text-field value="" v-model="form.bairro" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label> Município de residência </e-label>
            <v-text-field value="" v-model="form.municipio_residencia" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label> UF </e-label>
            <e-autocomplete
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.uf_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label> Zona de Residência </e-label>
            <e-autocomplete
              :items="$constants.zonaResidenciaList"
              :return-object="false"
              v-model="form.zona_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Localização diferenciada de residência</e-label>
            <e-autocomplete
              :items="$constants.localizacaoDiferenciadaDeResidenciaList"
              :return-object="false"
              v-model="form.zona_diferenciada_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Tipo de Professor:</e-label>
            <e-autocomplete
              :items="$constants.rolesParaProfessores"
              :return-object="false"
              v-model="form.role_id"
              :item-value="(role) => role.id"
              :item-text="(role) => role.label || role.name"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Franquia(s) do usuário:</e-label>
            <e-autocomplete
              :items="franquiasList"
              :return-object="false"
              v-model="form.user.franquias_permitidas"
              :item-value="(franquia) => franquia.id"
              :item-text="(franquia) => franquia.descricao"
              label="Selecione uma opção"
              dense
              multiple
              solo
              @change="onFranquiasChange"
            />
          </v-col>
          <v-col cols="12">
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              block
              >Enviar Dados</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    this.condicoesList = await this.$services.condicoesService.listar();
    this.loadFormData();
    this.loadData();
  },
  data() {
    return {
      professores: [],
      professoresList: [],
      franquiasList: [],
      carregandoProfessores: false,
      submittingForm: false,
      form: { user: {} },
      professor: null,
      alertaMensagem: "",
      alertaVisivel: false,
      franquiasOriginais: [],
      franquiasSelecionadas: [],
      condicoesList: [],
    };
  },
  watch: {
    form: {
      async handler(formValue) {
        try {
          const cepValue = this.$services.cepService.getCepInteiro(formValue.cep);
          if (cepValue) {
            const localizacao = await this.$services.cepService.buscarDadosDoCep(cepValue);
            this.form.municipio_residencia = localizacao.cidade;
            this.form.uf_residencia = localizacao.estado;
          }
        } catch (error) {
          this.$handleError("Erro ao buscar informações do CEP");
        }
      },
      deep: true,
    },
  },
  methods: {
    async listarProfessores() {
      try {
        this.professores = await this.$services.professoresService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async listarFranquias() {
      try {
        this.franquiasList = await this.$services.franquiasService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async onFranquiasChange(novasFranquias) {
      try {
        const anteriores = this.franquiasOriginais.map(Number);
        const novas = (novasFranquias || []).map(Number);

        const desmarcadas = anteriores.filter((id) => !novas.includes(id));

        const recusadas = await desmarcadas.reduce(async (accPromise, franquiaId) => {
          const acc = await accPromise;

          const response = await this.$services.professoresService.verificarVinculo({
            professor_id: this.form.id,
            franquia_id: franquiaId,
          });

          if (response.data.vinculado) {
            const listaGestoes = response.data.gestoes
              .map(
                (g) =>
                  `• Turma: <strong>${g.turma}</strong>, Disciplina: <strong>${g.disciplina}</strong>`
              )
              .join("<br>");

            const confirmado = await this.showConfirmModalComGestoes(listaGestoes);

            if (!confirmado) {
              acc.push(franquiaId);
            }
          }

          return acc;
        }, Promise.resolve([]));

        this.franquiasSelecionadas = [...novas, ...recusadas];
        this.form.user.franquias_permitidas = [...this.franquiasSelecionadas];
        this.franquiasOriginais = [...this.franquiasSelecionadas];
      } catch (error) {
        this.$handleError(error);
      }
    },

    showConfirmModalComGestoes(gestoesHTML) {
      return new Promise((resolve) => {
        this.$modals.danger({
          title: "Vínculo detectado",
          message: `
            Esta escola está vinculada aos seguintes diários do(a) professor(a):<br><br>
            ${gestoesHTML}<br><br>
            Entre em contato com a coordenação para esclarecimentos.<br><br>
            <strong>Deseja realmente desmarcar esta franquia do professor?</strong>
          `,
          buttons: [
            {
              text: "Não",
              callback: () => {
                this.$modals.close();
                resolve(false);
              },
              props: { color: "grey", small: true },
            },
            {
              text: "Sim",
              callback: () => {
                this.$modals.close();
                resolve(true);
              },
              props: { color: "red", small: true },
            },
          ],
        });
      });
    },

    async submitForm() {
      this.form.especial = Boolean(this.form.especial);
      this.submittingForm = true;
      try {
        if (this.editing) {
          await this.$services.professoresService.atualizarProfessor(this.form);
          this.$toast.success("Professor(a) Atualizado(a) com sucesso");
        } else {
          await this.$services.professoresService.criarProfessor(this.form);
          this.$toast.success("Professor(a) Criado(a) com sucesso");
        }
        this.$router.push({ name: "professores" });
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },

    async loadData() {
      try {
        if (this.professores.length === 0) {
          this.$loaderService.open("Carregando Professor");
        }
        await Promise.all([this.listarProfessores(), this.listarFranquias()]);
        const { professor_id } = this.$route.params;
        const data = await this.$services.professoresService.show(professor_id);

        const franquiasPermitidas = data.user?.franquias_permitidas || [];

        this.franquiasSelecionadas = [...franquiasPermitidas];
        this.franquiasOriginais = [...franquiasPermitidas];

        this.$loaderService.close();
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async loadFormData() {
      if (!this.professores || !this.editing) {
        return;
      }

      const { professor_id } = this.$route.params;

      try {
        this.carregandoProfessores = true;
        this.$loaderService.open("Carregando Professor(a)");

        const response = await this.$services.professoresService.getProfessor(professor_id);
        const professorData = response[0];
        this.form = {
          ...professorData,
          // API devolve a relação como array de objetos ({id, descricao, ...}); o
          // autocomplete trabalha com array de ids.
          condicoes: (professorData.condicoes ?? []).map((condicao) => condicao.id),
        };
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoProfessores = false;
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style></style>
